// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Loaded by the learn bundle (additive to the inline styles in public/learn.html).
   Used mostly for state-dependent visibility tweaks and the inline-ad variant. */

.learn-ad--inline {
    margin: 8px 0 16px;
}
`, "",{"version":3,"sources":["webpack://./src/learn/css/learn-page.css"],"names":[],"mappings":"AAAA;iFACiF;;AAEjF;IACI,kBAAkB;AACtB","sourcesContent":["/* Loaded by the learn bundle (additive to the inline styles in public/learn.html).\n   Used mostly for state-dependent visibility tweaks and the inline-ad variant. */\n\n.learn-ad--inline {\n    margin: 8px 0 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
